const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5001/api";

/*
 * React StrictMode can run useEffect twice immediately
 * during development.
 *
 * This variable exists only in memory.
 * It is NOT stored in sessionStorage/localStorage.
 *
 * Therefore:
 *
 * React StrictMode duplicate call -> ignored
 * Browser refresh -> counted again
 * New browser/tab -> counted
 */
let visitRequestInProgress = false;

async function hitVisit() {
  /*
   * Prevent React StrictMode from sending two
   * /visits/hit requests at the same time.
   */
  if (visitRequestInProgress) {
    return false;
  }

  visitRequestInProgress = true;

  try {
    const response = await fetch(`${API_URL}/visits/hit`, {
      method: "POST",
    });

    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }

    return true;
  } catch (error) {
    console.error("Visit tracking failed:", error);
    return false;
  } finally {
    /*
     * Release the lock after the request finishes.
     */
    visitRequestInProgress = false;
  }
}

async function fetchTotal() {
  try {
    const response = await fetch(`${API_URL}/visits/total`);

    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }

    const data = await response.json();

    return data.total;
  } catch (error) {
    console.error("Fetching total failed:", error);
    return null;
  }
}

export async function getSiteVisitCount() {
  /*
   * Only the first StrictMode call will execute this.
   * The second simultaneous call will be ignored.
   */
  await hitVisit();

  /*
   * Get the latest visitor count.
   */
  return fetchTotal();
}